
import { Outlet } from "react-router-dom"
import Header from "./Header"
import Footer from "./Footer"
import { Suspense } from "react"
import AutoLogout from "../Pages/LoginPage/AutoLogout"

export default function AppLayout() {
    return (
        <>
            <AutoLogout/>
            <Header />
            <main>
                <Suspense fallback={<div>Loading...</div>}>
                    <Outlet />
                </Suspense>
            </main>
            <Footer />
        </>
    )
}